<template>
  <b-card>
    <b-card-title>
      <h3>Location</h3>
    </b-card-title>
    <b-row v-if="trip">
      <b-col
        md="6"
        class="d-flex flex-column"
      >
        <h4>Pick-Up Location</h4>
        <div class="d-flex flex-column">
          <div>
            <span class="font-weight-bold">Address: </span>
            <span>{{ pickupAddress }}</span>
          </div>
          <div>
            <span class="font-weight-bold">lat/lng: </span>
            <span>{{ locationPickUpLat }},{{ locationPickUpLng }}</span>
            <b-button
              v-if="locationPickUpLat && locationPickUpLng"
              class="btn-icon rounded-circle"
              variant="flat-primary"
              @click="copyValueToClipboard(`${locationPickUpLat},${locationPickUpLng}`)"
            >
              <feather-icon
                icon="CopyIcon"
                size="20"
              />
            </b-button>
          </div>
        </div>
      </b-col>
      <b-col
        md="6"
        class="d-flex flex-column"
      >
        <h4>Drop-Off Location</h4>
        <div class="d-flex flex-column">
          <div>
            <span class="font-weight-bold">Address: </span>
            <span>{{ dropoffAddress }}</span>
          </div>
          <div>
            <span class="font-weight-bold">lat/lng: </span>
            <span>{{ locationDropoffLat }},{{ locationDropoffLng }}</span>
            <b-button
              v-if="locationDropoffLat && locationDropoffLng"
              class="btn-icon rounded-circle"
              variant="flat-primary"
              @click="copyValueToClipboard(`${locationDropoffLat},${locationDropoffLng}`)"
            >
              <feather-icon
                icon="CopyIcon"
                size="20"
              />
            </b-button>
          </div>
        </div>
      </b-col>
      <b-col
        md="6"
        class="d-flex flex-column"
      >
        <h4>Previous Drop-Off Location</h4>
        <div class="d-flex flex-column">
          <div>
            <span class="font-weight-bold">Address: </span>
            <span>{{ previousDropoffAddress }}</span>
          </div>
          <div>
            <span class="font-weight-bold">lat/lng: </span>
            <span>{{ previousDropoffLat }},{{ previousDropoffLng }}</span>
            <b-button
              v-if="previousDropoffLat && previousDropoffLng"
              class="btn-icon rounded-circle"
              variant="flat-primary"
              @click="copyValueToClipboard(`${previousDropoffLat},${previousDropoffLng}`)"
            >
              <feather-icon
                icon="CopyIcon"
                size="20"
              />
            </b-button>
          </div>
        </div>
      </b-col>
      <b-col
        v-if="locationActualDropoff"
        md="6"
      >
        <h4>Actual Drop-Off Location</h4>
        <div class="d-flex flex-column">
          <div>
            <span class="font-weight-bold">Address: </span>
            <span>{{ locationActualDropoff.address }}</span>
          </div>
          <div>
            <span class="font-weight-bold">lat/lng: </span>
            <span>{{ locationActualDropoff.latitude }},{{ locationActualDropoff.longitude }}</span>
            <b-button
              v-if="locationActualDropoff.latitude && locationActualDropoff.longitude"
              class="btn-icon rounded-circle"
              variant="flat-primary"
              @click="copyValueToClipboard(`${locationActualDropoff.latitude},${locationActualDropoff.longitude}`)"
            >
              <feather-icon
                icon="CopyIcon"
                size="20"
              />
            </b-button>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BCard, BCardTitle, BRow, BCol, BButton,
} from 'bootstrap-vue'
import { inject, computed } from '@vue/composition-api'
import { successNotification } from '@/utils/toast-notifications'

export default {
  components: {
    BCard,
    BCardTitle,
    BRow,
    BCol,
    BButton,
  },
  setup() {
    const copyValueToClipboard = val => {
      navigator.clipboard.writeText(val)
      successNotification('Copied to clipboard')
    }
    const trip = inject('trip')
    const locationPickUpLat = computed(() => trip.value?.metadata?.location?.pickup?.latitude)
    const locationPickUpLng = computed(() => trip.value?.metadata?.location?.pickup?.longitude)
    const locationDropoffLat = computed(() => trip.value?.metadata?.location?.dropoff?.latitude)
    const locationDropoffLng = computed(() => trip.value?.metadata?.location?.dropoff?.longitude)
    const locationActualDropoff = computed(() => trip.value?.metadata?.actual_drop_off)

    const pickupAddress = computed(() => trip.value?.metadata?.location?.pickup?.address)
    const dropoffAddress = computed(() => trip.value?.metadata?.location?.dropoff?.address)
    const previousDropoffAddress = computed(() => trip.value?.metadata?.location?.last_dropoff?.address)
    const previousDropoffLat = computed(() => trip.value?.metadata?.location?.last_dropoff?.latitude)
    const previousDropoffLng = computed(() => trip.value?.metadata?.location?.last_dropoff?.longitude)

    return {
      trip,
      copyValueToClipboard,
      locationPickUpLat,
      locationPickUpLng,
      locationDropoffLat,
      locationDropoffLng,
      locationActualDropoff,
      pickupAddress,
      dropoffAddress,
      previousDropoffAddress,
      previousDropoffLat,
      previousDropoffLng,
    }
  },
}
</script>

<style>

</style>
